import { render, staticRenderFns } from "./FixedHeader.vue?vue&type=template&id=2032457e&"
import script from "./FixedHeader.vue?vue&type=script&lang=js&"
export * from "./FixedHeader.vue?vue&type=script&lang=js&"
import style0 from "./FixedHeader.vue?vue&type=style&index=0&id=2032457e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports